export const membersCountWrapper = {}

export const channelMembers = {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    variants: {
        arrangeInRow: {
            true: {
                '> div': {
                    button: {width: '100%'},
                    width: '100%',
                },
                'alignItems': 'flex-start',
                'flexDirection': 'column',

            },
        },
    },
}
